import { stdObject } from "../../../../data/types/stdObject";

export const deleteOffer = (
  country: string,
  index: number,
  params: stdObject,
) => {
  const { windowValues2, setWindowValues2 } = params;
  let tempValues = windowValues2;
  tempValues.PRE.offers[country].splice(index, 1);
  setWindowValues2({ ...tempValues });
};
